(function() {
  'use strict';

  const taRoot = document.getElementById('takviye-asistani');
  if (!taRoot) return;

  const SHOP_URL = taRoot.dataset.shopDomain || (window.Shopify && window.Shopify.shop) || '';
  const STOREFRONT_TOKEN = taRoot.dataset.storefrontToken || '';
  const STOREFRONT_URL = SHOP_URL ? `https://${SHOP_URL}/api/2025-01/graphql.json` : '';
  const SHOPIFY_CUSTOMER_SEED = taRoot.dataset.customerSeed || '';
  const TA_NEW_ANALYSIS_TEXT = taRoot.dataset.newAnalysisText || 'Asistana Geri Dön';
  const TA_HARIC_TUTMA = (() => {
    try {
      const el = document.getElementById('ta-haric-tutma-data');
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      console.warn('Takviye Asistanı hariç tutma verisi okunamadı.', e);
      return {};
    }
  })();




  function taCompareLayoutStyleKur() {
    const oldStyle = document.getElementById('ta-compare-style');
    if (oldStyle) oldStyle.remove();

    let style = document.getElementById('ta-compare-layout-style-v59');
    if (style) return;

    style = document.createElement('style');
    style.id = 'ta-compare-layout-style-v59';
    style.textContent = `
      #takviye-asistani #ta-result-screen .ta-rec-actions.ta-rec-actions--compare,
      #takviye-asistani #ta-result-screen .ta-rec-mobile-actions.ta-rec-mobile-actions--compare {
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 12px !important;
        width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      #takviye-asistani #ta-result-screen .ta-rec-actions.ta-rec-actions--compare > .ta-rec-reason,
      #takviye-asistani #ta-result-screen .ta-rec-mobile-actions.ta-rec-mobile-actions--compare > .ta-rec-mobile-reason {
        width: 100% !important;
        max-width: none !important;
        flex: 0 0 auto !important;
        margin: 0 !important;
      }
      #takviye-asistani #ta-result-screen .ta-rec-cta-row,
      #takviye-asistani #ta-result-screen .ta-rec-mobile-cta-row {
        display: grid !important;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
        align-items: stretch !important;
        gap: 12px !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: none !important;
        height: 48px !important;
        min-height: 48px !important;
        max-height: 48px !important;
        flex: 0 0 auto !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      #takviye-asistani #ta-result-screen .ta-rec-mobile-cta-row {
        height: 56px !important;
        min-height: 56px !important;
        max-height: 56px !important;
      }
      #takviye-asistani #ta-result-screen .ta-rec-cta-row .ta-rec-link,
      #takviye-asistani #ta-result-screen .ta-rec-mobile-cta-row .ta-rec-mobile-link,
      #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-compare,
      #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-mobile-compare {
        display: flex !important;
        align-items: stretch !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: none !important;
        height: 100% !important;
        min-height: 100% !important;
        max-height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        flex: 1 1 0 !important;
        box-sizing: border-box !important;
      }
      #takviye-asistani #ta-result-screen .ta-rec-cta-row .ta-rec-link,
      #takviye-asistani #ta-result-screen .ta-rec-mobile-cta-row .ta-rec-mobile-link {
        align-items: center !important;
        justify-content: center !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
      }
      #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-compare input,
      #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-mobile-compare input {
        position: absolute !important;
        opacity: 0 !important;
        width: 1px !important;
        height: 1px !important;
        pointer-events: none !important;
      }
      #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-compare label,
      #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-mobile-compare label {
        width: 100% !important;
        height: 100% !important;
        min-height: 100% !important;
        max-height: 100% !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin: 0 !important;
        padding: 0 12px !important;
        border-radius: 14px !important;
        border: 1px solid rgba(1, 74, 10, 0.22) !important;
        background: linear-gradient(135deg, #ffffff 0%, #f6fbf7 100%) !important;
        color: #014a0a !important;
        font-size: 12.8px !important;
        font-weight: 900 !important;
        line-height: 1 !important;
        letter-spacing: .015em !important;
        text-transform: none !important;
        text-align: center !important;
        cursor: pointer !important;
        box-sizing: border-box !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        box-shadow: 0 7px 18px rgba(1, 74, 10, 0.07) !important;
      }
      #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-compare label:hover,
      #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-mobile-compare label:hover {
        background: linear-gradient(135deg, #f7fbf7 0%, #eef8ef 100%) !important;
        border-color: rgba(1, 74, 10, 0.36) !important;
        color: #012a06 !important;
        transform: translateY(-1px) !important;
        box-shadow: 0 9px 22px rgba(1, 74, 10, 0.10) !important;
      }
      #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-compare input:checked + label,
      #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-mobile-compare input:checked + label {
        background: linear-gradient(135deg, #eef8ef 0%, #e3f3e5 100%) !important;
        border-color: rgba(1, 74, 10, 0.42) !important;
        color: #012a06 !important;
      }
      @media (max-width: 480px) {
        #takviye-asistani #ta-result-screen .ta-rec-actions.ta-rec-actions--compare,
        #takviye-asistani #ta-result-screen .ta-rec-mobile-actions.ta-rec-mobile-actions--compare {
          gap: 12px !important;
        }
        #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-compare label,
        #takviye-asistani #ta-result-screen sc-add-to-compare.ta-rec-mobile-compare label {
          font-size: 13px !important;
          border-radius: 14px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  taCompareLayoutStyleKur();


  const secimler = {
    yas: null,
    cinsiyet: null,
    gebelik: null,
    kategoriler: [],
    form: null,
    kronikler: [],
    sorular: {}
  };

  const formScreen = document.getElementById('ta-form-screen');
  const loadingScreen = document.getElementById('ta-loading-screen');
  const resultScreen = document.getElementById('ta-result-screen');
  const resultsGrid = document.getElementById('ta-results-grid');

  const loadingMessages = [
    'Seçimlerin analiz ediliyor...',
    'Özel durum filtreleri uygulanıyor...',
    'Uygun ürünler sıralanıyor...'
  ];

  let loadingMessageInterval = null;
  let taViewEventSent = false;
  let taUrunlerPromise = null;
  let taPrefetchBaslatildi = false;
  let taCompareAllHandles = [];

  const TA_URUN_CACHE_KEY = 'takviye_asistani_urunler_cache_v3';
  const TA_URUN_CACHE_TTL = 5 * 60 * 1000;

  function taHeaderOffsetHesapla() {
    const candidates = [
      'sticky-header',
      '.shopify-section-header-sticky',
      '.section-header.shopify-section-header-sticky',
      '#shopify-section-header',
      'header'
    ];

    let offset = 0;

    candidates.forEach(selector => {
      const el = document.querySelector(selector);
      if (!el) return;

      const style = window.getComputedStyle(el);
      const rect = el.getBoundingClientRect();

      if (
        rect.height > 0 &&
        rect.top <= 2 &&
        (style.position === 'sticky' || style.position === 'fixed' || selector === '#shopify-section-header' || selector === 'header')
      ) {
        offset = Math.max(offset, Math.ceil(rect.height));
      }
    });

    return Math.min(Math.max(offset + 18, 92), 150);
  }

  function taSayfaUstuneGit() {
    const section = document.getElementById('takviye-asistani');
    const top = section
      ? section.getBoundingClientRect().top + window.pageYOffset - taHeaderOffsetHesapla()
      : 0;

    window.setTimeout(() => {
      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });
    }, 100);
  }

  function taStepScrollTo(step, offset = 110) {
    if (!step) return;

    window.setTimeout(() => {
      const rect = step.getBoundingClientRect();
      const top = rect.top + window.pageYOffset - offset;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });
    }, 120);
  }

  function taAccordionAc(stepKey, scrollIntoView = false) {
    const step = document.querySelector(`.ta-step[data-step="${stepKey}"]`);
    if (!step) return;

    step.classList.add('is-open');
    const trigger = step.querySelector('[data-ta-accordion-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    if (scrollIntoView) {
      const mobile = window.matchMedia('(max-width: 900px)').matches;
      taStepScrollTo(step, mobile ? 86 : 118);
    }
  }

  function taAccordionKapat(stepKey) {
    const step = document.querySelector(`.ta-step[data-step="${stepKey}"]`);
    if (!step) return;

    step.classList.remove('is-open');
    const trigger = step.querySelector('[data-ta-accordion-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function taAccordionKur() {
    document.querySelectorAll('#takviye-asistani [data-ta-accordion-trigger]').forEach(trigger => {
      const step = trigger.closest('.ta-step');
      if (!step) return;

      trigger.setAttribute('aria-expanded', step.classList.contains('is-open') ? 'true' : 'false');

      trigger.addEventListener('click', function() {
        const open = !step.classList.contains('is-open');
        step.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function taSonrakiAdimiAc(type) {
    if (type === 'yas') {
      taAccordionAc('cinsiyet', true);
      return;
    }

    if (type === 'cinsiyet') {
      if (secimler.cinsiyet === 'Kadın' && !yasCocukMu(secimler.yas)) {
        taAccordionAc('gebelik', true);
      } else {
        taAccordionAc('kategori', true);
      }
      return;
    }

    if (type === 'gebelik') {
      taAccordionAc('kategori', true);
      return;
    }

    if (type === 'kategori' && secimler.kategoriler.length > 0) {
      taAccordionAc('kronik', false);
      return;
    }

    if (type === 'kronik' && secimler.kronikler.length > 0) {
      taAccordionAc('form', false);
      return;
    }

    if (type === 'form') {
      taAccordionAc('sorular', true);
      return;
    }

    if (type === 'soru') {
      const soruSayisi = document.querySelectorAll('#takviye-asistani .ta-soru').length;
      const cevaplananSoruSayisi = Object.keys(secimler.sorular || {}).length;

      if (soruSayisi > 0 && cevaplananSoruSayisi >= soruSayisi) {
        const submitBtn = document.getElementById('ta-submit-btn');

        if (submitBtn) {

          window.setTimeout(() => {

            submitBtn.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });

          }, 120);

        }
      }
    }
  }

  function takviyeFormunuTemizle() {
    secimler.yas = null;
    secimler.cinsiyet = null;
    secimler.gebelik = null;
    secimler.kategoriler = [];
    secimler.form = null;
    secimler.kronikler = [];
    secimler.sorular = {};

    document.querySelectorAll('.ta-card').forEach(b => b.classList.remove('ta-card--selected'));
    document.querySelectorAll('.ta-step').forEach(step => step.classList.remove('is-open'));
    taAccordionAc('yas', false);

    cinsiyetSecenekleriniGuncelle();
    hamilelikKategoriGorunurlugunuGuncelle();
    menopozKategoriGorunurlugunuGuncelle();
    gebelikTemizle();
    temizleFormUyarilari();
    guncelleSonucOzeti();

    taCompareAllAlaniGuncelle([]);

    taSayfaUstuneGit();
  }

  taAccordionKur();

  function taArrayValue(value) {
    return Array.isArray(value) ? value.filter(Boolean).join('|') : (value || '');
  }

  function taAnalyticsPayload(extra = {}) {
    return {
      age_range: secimler.yas || '',
      gender: secimler.cinsiyet || '',
      pregnancy_status: secimler.gebelik || '',
      supplement_form: secimler.form || '',
      need_categories: taArrayValue(secimler.kategoriler),
      special_conditions: taArrayValue(secimler.kronikler.map(k => k === '' ? 'Yok' : k)),
      selected_category_count: Array.isArray(secimler.kategoriler) ? secimler.kategoriler.length : 0,
      selected_condition_count: Array.isArray(secimler.kronikler) ? secimler.kronikler.filter(k => k !== '').length : 0,
      ...extra
    };
  }

  function taGA4Event(eventName, params = {}) {
    const payload = {
      event_category: 'Takviye Asistanı',
      ...params
    };

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        ...payload
      });
    } catch (e) {
      console.warn('Takviye Asistanı GA4 event gönderilemedi:', eventName, e);
    }
  }


  function taCompareAllMetniniGuncelle(count) {
    const textEl = document.getElementById('ta-compare-all-text');
    if (!textEl) return;

    const template = textEl.dataset.template || textEl.textContent || 'Listelenen {count} ürünü tek seferde karşılaştır.';
    textEl.textContent = template.replace(/\{count\}/g, String(count));
  }

  function taCompareAllAlaniGuncelle(urunler = []) {
    const card = document.getElementById('ta-compare-all-card');
    if (!card) return;

    const handles = Array.from(new Set(
      (Array.isArray(urunler) ? urunler : [])
        .map(urun => urun && urun.handle)
        .filter(Boolean)
    ));

    taCompareAllHandles = handles;
    card.hidden = handles.length === 0;
    taCompareAllMetniniGuncelle(handles.length);
  }

  function taCompareAllTetikle() {
    const handles = Array.isArray(taCompareAllHandles) ? taCompareAllHandles.filter(Boolean) : [];
    if (handles.length === 0) return;

    const btn = document.getElementById('ta-compare-all-btn');
    if (btn) btn.classList.add('is-working');

    handles.forEach((handle, index) => {
      window.setTimeout(() => {
        const compareElements = Array.from(document.querySelectorAll('#takviye-asistani #ta-results-grid sc-add-to-compare'));
        const compareEl = compareElements.find(el => el.getAttribute('product-handle') === handle);
        const checkbox = compareEl ? compareEl.querySelector('input[type="checkbox"]') : null;

        if (checkbox && !checkbox.checked) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (checkbox) {
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (!checkbox || window.matchMedia('(max-width: 1024px)').matches) {
          try {
            window.dispatchEvent(new CustomEvent('sc:dynamic-compare-add', {
              detail: {
                productHandle: handle,
                product_handle: handle,
                handle: handle
              }
            }));
          } catch (e) {}
        }

        if (index === handles.length - 1 && btn) {
          window.setTimeout(() => {
            btn.classList.remove('is-working');
          }, 180);
        }
      }, index * 55);
    });

    taGA4Event('takviye_asistani_compare_all_click', taAnalyticsPayload({
      product_count: handles.length,
      product_handles: handles.join('|')
    }));
  }


  function taViewEventGonder() {
    if (taViewEventSent) return;
    taViewEventSent = true;

    taGA4Event('takviye_asistani_view', {
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }

  taViewEventGonder();

  function yasCocukMu(yas) {
    return ['4-10', '11-17'].includes(yas);
  }

  function normalizeText(value) {
      return String(value || '').trim().toLocaleLowerCase('tr-TR');
  }

  function getCardByValue(type, value) {
    return Array.from(document.querySelectorAll(`.ta-card[data-type="${type}"]`))
      .find(card => card.dataset.value === value);
  }

  function gebelikTemizle() {
    secimler.gebelik = null;

    const gebelikStep = document.getElementById('ta-gebelik-step');
    if (gebelikStep) {
      gebelikStep.style.display = 'none';
      gebelikStep.classList.remove('is-open');
      const gebelikTrigger = gebelikStep.querySelector('[data-ta-accordion-trigger]');
      if (gebelikTrigger) gebelikTrigger.setAttribute('aria-expanded', 'false');
    }

    document.querySelectorAll('.ta-card[data-type="gebelik"]').forEach(b => {
      b.classList.remove('ta-card--selected');
    });
  }

  function cinsiyetTemizle() {
    secimler.cinsiyet = null;

    document.querySelectorAll('.ta-card[data-type="cinsiyet"]').forEach(b => {
      b.classList.remove('ta-card--selected');
    });
  }

  function cinsiyetSecenekleriniGuncelle() {
    const kadinBtn = document.getElementById('ta-cinsiyet-kadin');
    const erkekBtn = document.getElementById('ta-cinsiyet-erkek');
    const title = document.getElementById('ta-cinsiyet-title');

    if (!kadinBtn || !erkekBtn) return;

    if (yasCocukMu(secimler.yas)) {
      if (title) title.textContent = 'Cinsiyet';

      kadinBtn.innerHTML = '👧 Kız Çocuk';
      kadinBtn.dataset.value = 'Kız Çocuk';

      erkekBtn.innerHTML = '👦 Erkek Çocuk';
      erkekBtn.dataset.value = 'Erkek Çocuk';

      gebelikTemizle();
    } else {
      if (title) title.textContent = 'Cinsiyet';

      kadinBtn.innerHTML = '👩 Kadın';
      kadinBtn.dataset.value = 'Kadın';

      erkekBtn.innerHTML = '👨 Erkek';
      erkekBtn.dataset.value = 'Erkek';
    }
  }


  function hamilelikKategoriGorunurlugunuGuncelle() {
    const hamilelikKategori = Array.from(document.querySelectorAll('.ta-card[data-type="kategori"]'))
      .find(card => normalizeText(card.dataset.value) === 'hamilelik ve doğum öncesi');

    if (!hamilelikKategori) return;

    const cinsiyet = normalizeText(secimler.cinsiyet);
    const gizle = ['erkek', 'kız çocuk', 'erkek çocuk'].includes(cinsiyet);

    if (gizle) {
      hamilelikKategori.classList.remove('ta-card--selected');
      hamilelikKategori.style.display = 'none';

      secimler.kategoriler = secimler.kategoriler.filter(
        kategori => normalizeText(kategori) !== 'hamilelik ve doğum öncesi'
      );
    } else {
      hamilelikKategori.style.display = '';
    }
  }


  function menopozKategoriGorunurlugunuGuncelle() {
    const menopozKategori = Array.from(document.querySelectorAll('.ta-card[data-type="kategori"]'))
      .find(card => normalizeText(card.dataset.value) === 'menopoz dönemi');

    if (!menopozKategori) return;

    const cinsiyet = normalizeText(secimler.cinsiyet);
    const gizle = ['erkek', 'kız çocuk', 'erkek çocuk'].includes(cinsiyet);

    if (gizle) {
      menopozKategori.classList.remove('ta-card--selected');
      menopozKategori.style.display = 'none';

      secimler.kategoriler = secimler.kategoriler.filter(
        kategori => normalizeText(kategori) !== 'menopoz dönemi'
      );
    } else {
      menopozKategori.style.display = '';
    }
  }

  function temizleFormUyarilari() {
    document.querySelectorAll('.ta-step').forEach(step => {
      step.classList.remove('ta-step--error');
    });

    const warning = document.getElementById('ta-form-warning');
    if (warning) {
      warning.style.display = 'none';
      warning.innerHTML = '';
    }
  }

  function temizleStepHatalari() {
    document.querySelectorAll('.ta-step').forEach(step => {
      step.classList.remove('ta-step--error');
    });
  }

  function stepHataEkle(stepKey) {
    const step = document.querySelector(`.ta-step[data-step="${stepKey}"]`);
    if (step) {
      step.classList.add('ta-step--error');
      taAccordionAc(stepKey, false);
    }
  }

  function formGecerliMi(scrollEt = true) {
    temizleStepHatalari();

    const eksikler = [];
    const soruSayisi = document.querySelectorAll('.ta-soru').length;

    if (!secimler.yas) {
      eksikler.push('Yaş Aralığı');
      stepHataEkle('yas');
    }

    if (!secimler.cinsiyet) {
      eksikler.push('Cinsiyet');
      stepHataEkle('cinsiyet');
    }

    if (
      secimler.cinsiyet === 'Kadın' &&
      !yasCocukMu(secimler.yas) &&
      !secimler.gebelik
    ) {
      eksikler.push('Gebelik Durumu');
      stepHataEkle('gebelik');
    }

    if (!secimler.kategoriler || secimler.kategoriler.length === 0) {
      eksikler.push('İhtiyacına Göre');
      stepHataEkle('kategori');
    }

    if (soruSayisi > 0 && Object.keys(secimler.sorular).length < soruSayisi) {
      eksikler.push('Önemli Bilgiler');
      stepHataEkle('sorular');
    }

    if (!secimler.kronikler || secimler.kronikler.length === 0) {
      eksikler.push('Özel Durumlar');
      stepHataEkle('kronik');
    }

    if (!secimler.form) {
      eksikler.push('Ürün Formu Tercihi');
      stepHataEkle('form');
    }

    const warning = document.getElementById('ta-form-warning');

    if (eksikler.length > 0) {
      taGA4Event('takviye_asistani_validation_error', {
        missing_fields: eksikler.join('|'),
        missing_field_count: eksikler.length
      });

      if (warning) {
        warning.style.display = 'block';
        warning.innerHTML = `
          Önerileri hazırlayabilmem için lütfen eksik alanları tamamla:<br>
          <strong>${eksikler.join(', ')}</strong>
        `;
      }

      if (scrollEt) scrollToTakviyeAsistani();
      return false;
    }

    if (warning) {
      warning.style.display = 'none';
      warning.innerHTML = '';
    }

    return true;
  }

  document.querySelectorAll('.ta-card').forEach(btn => {
    btn.addEventListener('click', function() {
      const type = this.dataset.type;
      const value = this.dataset.value;
      const warningAktif = document.getElementById('ta-form-warning')?.style.display === 'block';

      if (type === 'kategori') {
        const isFarketmez = normalizeText(value) === 'farketmez';

        if (isFarketmez) {
          document.querySelectorAll('.ta-card[data-type="kategori"]').forEach(b => {
            b.classList.remove('ta-card--selected');
          });

          this.classList.add('ta-card--selected');
          secimler.kategoriler = [value];

        } else {
          document.querySelectorAll('.ta-card[data-type="kategori"]').forEach(b => {
            if (normalizeText(b.dataset.value) === 'farketmez') {
              b.classList.remove('ta-card--selected');
            }
          });

          this.classList.toggle('ta-card--selected');

          secimler.kategoriler = secimler.kategoriler.filter(k => normalizeText(k) !== 'farketmez');

          if (secimler.kategoriler.includes(value)) {
            secimler.kategoriler = secimler.kategoriler.filter(k => k !== value);
          } else {
            secimler.kategoriler.push(value);
          }
        }

      } else if (type === 'kronik') {
        const yokSecildi = value === '';

        if (yokSecildi) {
          document.querySelectorAll('.ta-card[data-type="kronik"]').forEach(b => {
            b.classList.remove('ta-card--selected');
          });

          this.classList.add('ta-card--selected');
          secimler.kronikler = [''];

        } else {
          document.querySelectorAll('.ta-card[data-type="kronik"]').forEach(b => {
            if (b.dataset.value === '') {
              b.classList.remove('ta-card--selected');
            }
          });

          this.classList.toggle('ta-card--selected');

          secimler.kronikler = secimler.kronikler.filter(k => k !== '');

          if (secimler.kronikler.includes(value)) {
            secimler.kronikler = secimler.kronikler.filter(k => k !== value);
          } else {
            secimler.kronikler.push(value);
          }
        }

      } else if (type === 'soru') {
        const alan = this.dataset.alan;

        document.querySelectorAll(`.ta-card[data-type="soru"][data-alan="${alan}"]`).forEach(b => {
          b.classList.remove('ta-card--selected');
        });

        this.classList.add('ta-card--selected');

        secimler.sorular[alan] = {
          value: value,
          kontra: this.dataset.kontra === 'true'
        };

      } else {
        document.querySelectorAll(`.ta-card[data-type="${type}"]`).forEach(b => {
          b.classList.remove('ta-card--selected');
        });

        this.classList.add('ta-card--selected');

        secimler[
          type === 'yas' ? 'yas' :
          type === 'cinsiyet' ? 'cinsiyet' :
          type === 'form' ? 'form' :
          type === 'gebelik' ? 'gebelik' :
          type
        ] = value;

        if (type === 'yas') {
          cinsiyetTemizle();
          gebelikTemizle();
          cinsiyetSecenekleriniGuncelle();
          hamilelikKategoriGorunurlugunuGuncelle();
          menopozKategoriGorunurlugunuGuncelle();
        }

        if (type === 'cinsiyet') {
          hamilelikKategoriGorunurlugunuGuncelle();
          menopozKategoriGorunurlugunuGuncelle();

          const gebelikStep = document.getElementById('ta-gebelik-step');

          if (value === 'Kadın' && !yasCocukMu(secimler.yas)) {
            if (gebelikStep) {
              gebelikStep.style.display = 'block';
              taAccordionAc('gebelik', true);
            }
          } else {
            gebelikTemizle();
          }
        }
      }

      taSonrakiAdimiAc(type);

      guncelleSonucOzeti();

      taGA4Event('takviye_asistani_selection', {
        selection_type: type || '',
        selection_value: value || '',
        ...taAnalyticsPayload()
      });

      if (warningAktif) {
        formGecerliMi(false);
      }
    });
  });

  function scrollToTakviyeAsistani() {
    const section = document.getElementById('takviye-asistani');

    if (section) {
      const headerHeight = document.querySelector('header')?.offsetHeight || 80;

      window.scrollTo({
        top: section.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20,
        behavior: 'smooth'
      });
    }
  }

  document.getElementById('ta-submit-btn').addEventListener('click', async function() {
    if (!formGecerliMi(true)) return;

    taGA4Event('takviye_asistani_submit', taAnalyticsPayload());

    showScreen('loading');
    scrollToTakviyeAsistani();

    try {
      const urunler = await tumUrunleriCek();
      const sonuclar = await filtrele(urunler);

      gosterSonuclar(sonuclar);
      showScreen('result');
      pushResultHistoryState();

      setTimeout(scrollToTakviyeAsistani, 100);

    } catch(e) {
      console.error('Takviye Asistanı hata:', e);

      taGA4Event('takviye_asistani_error', {
        error_message: e && e.message ? String(e.message).slice(0, 120) : 'unknown_error',
        ...taAnalyticsPayload()
      });

      showScreen('result');
      pushResultHistoryState();
      guncelleSonucAciklamasi(0);
      yasalUyariGorunurlugunuAyarla(false);
      resultsGrid.innerHTML = '<div class="ta-empty">Bir hata oluştu. Lütfen tekrar deneyin.</div>';

      setTimeout(scrollToTakviyeAsistani, 100);
    }
  });

  const taEditSelectionBtn = document.getElementById('ta-edit-selection-btn');
  if (taEditSelectionBtn) {
    taEditSelectionBtn.addEventListener('click', function() {
      taGA4Event('takviye_asistani_edit_selection', taAnalyticsPayload());
      showScreen('form');
      taSayfaUstuneGit();
      replaceFormHistoryState();
    });
  }

  function taSonucEkranindanFormaDon(resetForm = true) {
    taGA4Event('takviye_asistani_back_to_form', taAnalyticsPayload());

    if (resetForm) {
      taGA4Event('takviye_asistani_reset');
      takviyeFormunuTemizle();
    }

    showScreen('form');
    taSayfaUstuneGit();
    replaceFormHistoryState();
  }

  const taResetBtn = document.getElementById('ta-reset-btn');
  if (taResetBtn) {
    taResetBtn.addEventListener('click', function() {
      taSonucEkranindanFormaDon(true);
    });
  }

  const taMobileResetBtn = document.getElementById('ta-mobile-reset-btn');
  if (taMobileResetBtn) {
    taMobileResetBtn.addEventListener('click', function() {
      taSonucEkranindanFormaDon(true);
    });
  }

  document.addEventListener('click', function(event) {
    const emptyBackBtn = event.target.closest('#takviye-asistani [data-ta-empty-back]');
    if (!emptyBackBtn) return;

    taGA4Event('takviye_asistani_empty_back_to_form', taAnalyticsPayload());
    showScreen('form');
    taSayfaUstuneGit();
    replaceFormHistoryState();
  });

  const taClearFormBtn = document.getElementById('ta-clear-form-btn');
  if (taClearFormBtn) {
    taClearFormBtn.addEventListener('click', function() {
      taGA4Event('takviye_asistani_clear_form', taAnalyticsPayload());
      takviyeFormunuTemizle();
    });
  }

  function guncelleSonucOzeti() {
    const ozet = document.getElementById('ta-secim-ozeti');
    const etiketler = document.getElementById('ta-ozet-etiketler');

    if (!ozet || !etiketler) return;

    const items = [];

    if (secimler.yas) items.push({ label: 'Yaş Aralığı', value: secimler.yas });
    if (secimler.cinsiyet) items.push({ label: 'Cinsiyet', value: secimler.cinsiyet });
    if (secimler.gebelik) items.push({ label: 'Gebelik Durumu', value: secimler.gebelik });
    if (secimler.form) items.push({ label: 'Ürün Formu', value: secimler.form });

    secimler.kronikler.forEach(k => {
      items.push({
        label: 'Özel Durum',
        value: k === '' ? 'Yok' : k
      });
    });

    secimler.kategoriler.forEach(k => {
      items.push({ label: 'İhtiyacına Göre', value: k });
    });

    Object.values(secimler.sorular).forEach(s => {
      if (s.value) items.push({ label: 'Önemli Bilgiler', value: s.value });
    });

    if (items.length === 0) {
      ozet.style.display = 'none';
      return;
    }

    ozet.style.display = 'flex';

    etiketler.innerHTML = items.map(i =>
      `<span class="ta-ozet-etiket"><span class="ta-ozet-etiket-baslik">${i.label}:</span> ${i.value}</span>`
    ).join('');
  }

  function sonucOzetSatirlariOlustur() {
    const rows = [];

    if (secimler.yas) rows.push({ label: 'Yaş Aralığı', value: secimler.yas, icon: '♙' });
    if (secimler.cinsiyet) rows.push({ label: 'Cinsiyet', value: secimler.cinsiyet, icon: '♁' });

    const gebelikGoster = secimler.cinsiyet === 'Kadın' && !yasCocukMu(secimler.yas);
    if (gebelikGoster || secimler.gebelik) {
      rows.push({ label: 'Gebelik / Emzirme', value: secimler.gebelik || 'Hayır', icon: '♧' });
    }

    if (secimler.kategoriler && secimler.kategoriler.length > 0) {
      rows.push({ label: 'İhtiyaç Alanı', value: secimler.kategoriler.join(', '), icon: '⌘' });
    }

    if (secimler.kronikler && secimler.kronikler.length > 0) {
      const kronikText = secimler.kronikler.map(k => k === '' ? 'Yok' : k).join(', ');
      rows.push({ label: 'Özel Durumlar', value: kronikText || 'Yok', icon: '♢' });
    } else {
      rows.push({ label: 'Özel Durumlar', value: 'Yok', icon: '♢' });
    }

    if (secimler.form) rows.push({ label: 'Ürün Formu', value: secimler.form, icon: '▣' });

    const soruEntries = Object.entries(secimler.sorular || {});
    if (soruEntries.length > 0) {
      const evetSayisi = soruEntries.filter(([, data]) => data && data.value === 'Evet').length;
      const hayirSayisi = soruEntries.filter(([, data]) => data && data.value === 'Hayır').length;
      let bilgiText = '';

      if (evetSayisi > 0 && hayirSayisi > 0) {
        bilgiText = `${evetSayisi} Evet / ${hayirSayisi} Hayır`;
      } else if (evetSayisi > 0) {
        bilgiText = `${evetSayisi} Evet`;
      } else {
        bilgiText = 'Hepsi Hayır';
      }

      rows.push({ label: 'Önemli Bilgiler', value: bilgiText, icon: 'ⓘ' });
    }

    return rows;
  }

  function taMobilSonucOzetiVarsayilanKapat() {
  
    const trigger = document.querySelector('#takviye-asistani [data-ta-result-panel="summary"]');
    const content = document.querySelector('#takviye-asistani [data-ta-result-panel-content="summary"]');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('is-open');
    }

    if (content) {
      content.hidden = true;
    }
  }

  function guncelleSonucPaneli(resultCount = 0) {
    const summaryList = document.getElementById('ta-result-summary-list');
    const aiSummary = document.getElementById('ta-result-ai-summary');

    if (summaryList) {
      const rows = sonucOzetSatirlariOlustur();
      summaryList.innerHTML = rows.map(row => `
        <div class="ta-result-summary-row">
          <span class="ta-result-summary-icon" aria-hidden="true">${escapeHTML(row.icon)}</span>
          <span class="ta-result-summary-label">${escapeHTML(row.label)}</span>
          <strong title="${escapeHTML(row.value)}">${escapeHTML(row.value)}</strong>
        </div>
      `).join('');
    }

if (aiSummary) {

  const kategoriler = Array.isArray(secimler.kategoriler)
    ? secimler.kategoriler.filter(Boolean)
    : [];

  const normalizeText = (value) =>
    String(value || '').trim().toLocaleLowerCase('tr-TR');

  const isFarketmez = (value) =>
    normalizeText(value) === 'farketmez';

  const kategoriSecimleri = kategoriler.filter(
    kategori => !isFarketmez(kategori)
  );

  const gosterilecekKategoriler =
    kategoriSecimleri.slice(0, 3);

  const kalanKategoriSayisi =
    kategoriSecimleri.length - gosterilecekKategoriler.length;

  const isFormFarketmez =
    isFarketmez(secimler.form);

  const kategoriText =
    gosterilecekKategoriler.length > 0
      ? gosterilecekKategoriler.join(' / ')
      : null;

  const kategoriLabel =
    gosterilecekKategoriler.length === 1
      ? 'ihtiyaç alanı'
      : 'ihtiyaç alanları';

  const kategoriWithExtraText =
    kategoriText && kalanKategoriSayisi > 0
      ? `${kategoriText} ve ${kalanKategoriSayisi} farklı ihtiyaç alanı`
      : kategoriText
        ? `${kategoriText} ${kategoriLabel}`
        : null;

  const formText =
    !isFormFarketmez && secimler.form
      ? `${secimler.form} formu`
      : null;

  let summaryIntro = '';

  if (kategoriWithExtraText && formText) {

    summaryIntro =
      `Seçimlerine göre ${kategoriWithExtraText} ile ${formText} önceliklendirildi.`;

  } else if (kategoriWithExtraText && !formText) {

    summaryIntro =
      `Seçimlerine göre ${kategoriWithExtraText} önceliklendirildi. Ürün formunda özel bir tercih belirtilmedi.`;

  } else if (!kategoriWithExtraText && formText) {

    summaryIntro =
      `Seçimlerine göre özel bir ihtiyaç alanı önceliklendirilmedi. ${formText} dikkate alındı.`;

  } else {

    summaryIntro =
      `Seçimlerine göre özel bir ihtiyaç alanı veya ürün formu önceliklendirilmedi.`;

  }

  aiSummary.textContent =
    `${summaryIntro} Ürünler, özel durumların ve içerik uyumları dikkate alınarak sıralandı.`;

}
  }

  function loadingAnimasyonunuBaslat() {
    const loadingText = document.getElementById('ta-loading-text');

    if (!loadingText) return;

    let index = 0;
    loadingText.textContent = loadingMessages[0];

    clearInterval(loadingMessageInterval);

    loadingMessageInterval = setInterval(() => {
      if (index >= loadingMessages.length - 1) {
        clearInterval(loadingMessageInterval);
        loadingMessageInterval = null;
        return;
      }

      index += 1;
      loadingText.textContent = loadingMessages[index];
    }, 900);
  }

  function loadingAnimasyonunuDurdur() {
    clearInterval(loadingMessageInterval);
    loadingMessageInterval = null;
  }

  function ekranGecisAnimasyonuUygula(screenEl) {
    if (!screenEl) return;

    screenEl.classList.remove('ta-screen--entering');
    void screenEl.offsetWidth;
    screenEl.classList.add('ta-screen--entering');

    window.setTimeout(() => {
      screenEl.classList.remove('ta-screen--entering');
    }, 340);
  }

  function showScreen(screen) {
    formScreen.classList.add('ta-screen--hidden');
    loadingScreen.classList.add('ta-screen--hidden');
    resultScreen.classList.add('ta-screen--hidden');

    if (screen === 'form') {
      loadingAnimasyonunuDurdur();
      formScreen.classList.remove('ta-screen--hidden');
      ekranGecisAnimasyonuUygula(formScreen);

    } else if (screen === 'loading') {
      loadingScreen.classList.remove('ta-screen--hidden');
      ekranGecisAnimasyonuUygula(loadingScreen);
      loadingAnimasyonunuBaslat();

    } else if (screen === 'result') {
      loadingAnimasyonunuDurdur();
      resultScreen.classList.remove('ta-screen--hidden');
      ekranGecisAnimasyonuUygula(resultScreen);
    }
  }

  function initTakviyeHistoryState() {
    if (!window.history || !window.history.replaceState) return;

    if (!history.state || !history.state.taScreen) {
      history.replaceState({ taScreen: 'form' }, '', window.location.href);
    }
  }

  function pushResultHistoryState() {
    if (!window.history || !window.history.pushState) return;

    if (!history.state || history.state.taScreen !== 'result') {
      history.pushState({ taScreen: 'result' }, '', window.location.href);
    }
  }

  function replaceFormHistoryState() {
    if (!window.history || !window.history.replaceState) return;

    history.replaceState({ taScreen: 'form' }, '', window.location.href);
  }

  initTakviyeHistoryState();

  window.addEventListener('popstate', function(event) {
    if (event.state && event.state.taScreen === 'form') {
      showScreen('form');
      taSayfaUstuneGit();
      return;
    }

    if (event.state && event.state.taScreen === 'result') {
      showScreen('result');
      setTimeout(scrollToTakviyeAsistani, 100);
    }
  });

  async function tumUrunleriCekKaynak() {
    const urunler = [];
    let cursor = null;
    let devam = true;

    while (devam) {
      const afterClause = cursor ? `, after: "${cursor}"` : '';
      const query = `{
        products(first: 250${afterClause}) {
          pageInfo { hasNextPage endCursor }
          edges {
            node {
              id title handle vendor descriptionHtml tags
              featuredImage { url altText }
              priceRange { minVariantPrice { amount currencyCode } }
              variants(first: 1) {
                edges {
                  node {
                    id
                  }
                }
              }
              metafields(identifiers: [
                {namespace: "custom", key: "urun_formu"},
                {namespace: "custom", key: "hedef_yas_grubu"},
                {namespace: "custom", key: "11_yas_gunluk_kullanim_miktari"},
                {namespace: "custom", key: "18_yas_gunluk_kullanim_miktari"},
                {namespace: "custom", key: "50_yas_gunluk_kullanim_miktari"},
                {namespace: "custom", key: "70_yas_gunluk_kullanim_miktari"}
              ]) {
                namespace key value
              }
            }
          }
        }
      }`;

      const resp = await fetch(STOREFRONT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query })
      });

      const json = await resp.json();
      const products = json.data?.products;

      if (!products) {
        devam = false;
        break;
      }

      products.edges.forEach(({ node: p }) => {
        urunler.push({
          id: p.id,
          title: p.title,
          handle: p.handle,
          vendor: p.vendor,
          descriptionHtml: p.descriptionHtml,
          tags: p.tags,
          featuredImage: p.featuredImage,
          priceRange: p.priceRange,
          metafields: p.metafields || [],
          variants: p.variants || { edges: [] }
        });
      });

      if (products.pageInfo.hasNextPage) {
        cursor = products.pageInfo.endCursor;
      } else {
        devam = false;
      }
    }

    return urunler;
  }

  function urunCacheOku() {
    try {
      const cached = sessionStorage.getItem(TA_URUN_CACHE_KEY);
      if (!cached) return null;

      const parsed = JSON.parse(cached);
      if (!parsed || !Array.isArray(parsed.data) || !parsed.ts) return null;

      if (Date.now() - parsed.ts > TA_URUN_CACHE_TTL) {
        sessionStorage.removeItem(TA_URUN_CACHE_KEY);
        return null;
      }

      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function urunCacheYaz(urunler) {
    try {
      sessionStorage.setItem(TA_URUN_CACHE_KEY, JSON.stringify({
        data: urunler,
        ts: Date.now()
      }));
    } catch (e) {
      // Cache yazılamazsa öneri akışı normal fetch ile çalışmaya devam eder.
    }
  }

  async function tumUrunleriCek() {
    const cached = urunCacheOku();
    if (cached) return cached;

    if (taUrunlerPromise) return taUrunlerPromise;

    taUrunlerPromise = tumUrunleriCekKaynak()
      .then(urunler => {
        urunCacheYaz(urunler);
        return urunler;
      })
      .finally(() => {
        taUrunlerPromise = null;
      });

    return taUrunlerPromise;
  }

  function takviyeAsistaniPrefetchBaslat() {
    if (taPrefetchBaslatildi || urunCacheOku()) return;

    taPrefetchBaslatildi = true;

    tumUrunleriCek().catch(() => {
      taPrefetchBaslatildi = false;
    });
  }

  function takviyeAsistaniPrefetchKur() {
    const section = document.getElementById('takviye-asistani');
    if (!section) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) return;

        observer.disconnect();
        takviyeAsistaniPrefetchBaslat();
      }, {
        root: null,
        rootMargin: '350px 0px',
        threshold: 0
      });

      observer.observe(section);
      return;
    }

    setTimeout(takviyeAsistaniPrefetchBaslat, 1200);
  }

  function formTercihiUyumluMu(seciliForm, urunFormu) {
    if (!seciliForm || !urunFormu) return false;
    if (['yok', 'farketmez'].includes(normalizeText(seciliForm))) return false;

    const FORM_MAP = {
      'Kapsül': ['Kapsül', 'Kapsül (Softgel)'],
      'Tablet': ['Tablet', 'Dilaltı Tablet', 'Çiğneme Tableti'],
      'Çiğnenebilir': ['Çiğnenebilir Form', 'Çiğneme Tableti'],
      'Efervesan Tablet': ['Efervesan Tablet'],
      'Sıvı': ['Sıvı', 'Sıvı/Damla', 'Sıvı/Shot', 'Sıvı/Şişe', 'Sıvı/Tüp'],
      'Sprey': ['Sprey', 'Sprey/Damla'],
      'Toz': ['Toz'],
      'Saşe': ['Saşe'],
      'Pastil': ['Pastil']
    };

    const eslesecekFormlar = FORM_MAP[seciliForm] || [seciliForm];

    return eslesecekFormlar.some(f => normalizeText(f) === normalizeText(urunFormu));
  }

  function yasGrubuUyumluMu(yas, yasGrubu) {
    if (!yas || !yasGrubu) return false;

    const YAS_MAP = {
      '4-10': ['Çocuk', 'Yetişkin & Çocuk'],
      '11-17': ['Yetişkin', 'Yetişkin & Çocuk'],
      '18-24': ['Yetişkin', 'Yetişkin & Çocuk', 'Yetişkin Erkek', 'Yetişkin Kadın'],
      '25-34': ['Yetişkin', 'Yetişkin & Çocuk', 'Yetişkin Erkek', 'Yetişkin Kadın'],
      '35-44': ['Yetişkin', 'Yetişkin & Çocuk', 'Yetişkin Erkek', 'Yetişkin Kadın'],
      '45-54': ['Yetişkin', 'Yetişkin & Çocuk', 'Yetişkin Erkek', 'Yetişkin Kadın'],
      '55+': ['Yetişkin', 'Yetişkin & Çocuk', 'Yetişkin Erkek', 'Yetişkin Kadın']
    };

    return (YAS_MAP[yas] || []).includes(yasGrubu);
  }

  function nedenleriOlustur(urun) {
    const nedenler = [];
    const yasGrubu = getMetafield(urun.metafields, 'custom', 'hedef_yas_grubu');
    const urunFormu = getMetafield(urun.metafields, 'custom', 'urun_formu');

    if (
      secimler.kategoriler &&
      secimler.kategoriler.length > 0 &&
      !secimler.kategoriler.some(k => normalizeText(k) === 'farketmez')
    ) {
      nedenler.push('Seçtiğin ihtiyaçlar doğrultusunda öne çıkıyor.');
    }

    if (formTercihiUyumluMu(secimler.form, urunFormu)) {
      nedenler.push('Ürün formu tercihinle uyumlu.');
    }

    if (yasGrubuUyumluMu(secimler.yas, yasGrubu)) {
      nedenler.push('Yaş aralığına uygun ürünler arasında yer alıyor.');
    }

    if (secimler.cinsiyet === 'Kadın' && yasGrubu === 'Yetişkin Kadın') {
      nedenler.push('Kadın kullanıcılar için tanımlanan ürünler arasında yer alıyor.');
    }

    if (secimler.cinsiyet === 'Erkek' && yasGrubu === 'Yetişkin Erkek') {
      nedenler.push('Erkek kullanıcılar için tanımlanan ürünler arasında yer alıyor.');
    }

    if (secimler.kronikler && secimler.kronikler.length > 0) {
      nedenler.push('Seçtiğin özel durum filtreleri dikkate alınarak listelendi.');
    }

    if (Object.keys(secimler.sorular).length > 0) {
      nedenler.push('Ek kullanım bilgilerin filtreleme sürecine dahil edildi.');
    }

    if (nedenler.length === 0) {
      nedenler.push('Seçimlerine göre oluşturulan öneri havuzunda yer alıyor.');
    }

    return nedenler.slice(0, 3);
  }

  function stableHash(value) {
    const str = String(value || '');
    let hash = 0;

    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0;
    }

    return Math.abs(hash);
  }

  function anonimKullaniciSeedAl() {
    if (SHOPIFY_CUSTOMER_SEED) {
      return `customer_${stableHash(String(SHOPIFY_CUSTOMER_SEED))}`;
    }

    const key = 'takviye_asistani_anonim_seed_v1';

    try {
      const mevcut = localStorage.getItem(key);
      if (mevcut) return mevcut;

      let yeniSeed = '';

      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        const bytes = new Uint32Array(4);
        window.crypto.getRandomValues(bytes);
        yeniSeed = `anon_${Array.from(bytes).map(v => v.toString(36)).join('_')}`;
      } else {
        yeniSeed = `anon_${Date.now().toString(36)}_${stableHash([
          navigator.userAgent || '',
          window.location.hostname || '',
          Date.now()
        ].join('|')).toString(36)}`;
      }

      localStorage.setItem(key, yeniSeed);
      return yeniSeed;
    } catch (e) {
      return `session_${stableHash([
        navigator.userAgent || '',
        window.location.hostname || '',
        new Date().toDateString()
      ].join('|'))}`;
    }
  }

  function secimTohumuOlustur() {
    return [
      secimler.yas || '',
      secimler.cinsiyet || '',
      secimler.gebelik || '',
      secimler.form || '',
      Array.isArray(secimler.kategoriler) ? [...secimler.kategoriler].sort().join('|') : '',
      Array.isArray(secimler.kronikler) ? [...secimler.kronikler].sort().join('|') : '',
      Object.keys(secimler.sorular || {})
        .sort()
        .map(alan => {
          const cevap = secimler.sorular[alan] || {};
          return `${alan}:${cevap.value || ''}`;
        })
        .join('|')
    ].join('::');
  }

  function skorSiraliListele(urunler) {
    if (!Array.isArray(urunler)) return [];

    return [...urunler].sort((a, b) => {
      const skorFarki = (Number(b.uyumSkoru) || 0) - (Number(a.uyumSkoru) || 0);
      if (skorFarki !== 0) return skorFarki;

      const bNeden = Array.isArray(b.nedenler) ? b.nedenler.length : 0;
      const aNeden = Array.isArray(a.nedenler) ? a.nedenler.length : 0;
      if (bNeden !== aNeden) return bNeden - aNeden;

      return stableHash(b.handle || b.id || b.title) - stableHash(a.handle || a.id || a.title);
    });
  }

  function urunMarkasiAl(urun) {
    return normalizeText(urun.vendor || (urun.title || '').split(' ')[0] || 'marka-yok');
  }

  function kategoriAnahtarlariniAl(kategori) {
    const card = getCardByValue('kategori', kategori);
    const raw = card?.dataset?.keywords || '';

    const keywords = raw
      .replace(/&#10;/g, '\n')
      .split(/[\n,]+/)
      .map(k => normalizeText(k))
      .filter(Boolean);

    keywords.push(normalizeText(kategori));

    return [...new Set(keywords)];
  }

  function urunKategoriEslesmeleri(urun) {
    if (!Array.isArray(secimler.kategoriler)) return [];

    const seciliKategoriler = secimler.kategoriler
      .filter(k => normalizeText(k) !== 'farketmez');

    if (seciliKategoriler.length === 0) return [];

    const metin = getTumMetinler(urun);

    return seciliKategoriler.filter(kategori => {
      const anahtarlar = kategoriAnahtarlariniAl(kategori);
      return anahtarlar.some(keyword => keyword && metin.includes(keyword));
    });
  }

  function akilliCesitliUrunSec(skorlanmisSonuc, oneriSayisi) {
    if (!Array.isArray(skorlanmisSonuc) || skorlanmisSonuc.length === 0) return [];

    const hedefSayi = Math.max(1, Number(oneriSayisi) || 6);
    const enYuksekSkor = Number(skorlanmisSonuc[0]?.uyumSkoru) || 0;
    const adayAltSkorSiniri = Math.max(75, enYuksekSkor - 10);
    const minimumAdaySayisi = Math.min(skorlanmisSonuc.length, Math.max(hedefSayi * 4, 18));

    let adaylar = skorlanmisSonuc
      .filter(u => (Number(u.uyumSkoru) || 0) >= adayAltSkorSiniri)
      .slice(0, Math.max(minimumAdaySayisi, hedefSayi));

    if (adaylar.length < hedefSayi) {
      adaylar = skorlanmisSonuc.slice(0, Math.min(skorlanmisSonuc.length, Math.max(minimumAdaySayisi, hedefSayi)));
    }

    const kullaniciSeed = anonimKullaniciSeedAl();
    const secimTohumu = secimTohumuOlustur();
    const seciliKategoriler = (secimler.kategoriler || []).filter(k => normalizeText(k) !== 'farketmez');
    const secilenler = [];
    const kullanilanIdler = new Set();
    const markaSayilari = new Map();
    const kapsananKategoriler = new Set();

    function ekle(urun) {
      if (!urun || kullanilanIdler.has(urun.id)) return false;

      kullanilanIdler.add(urun.id);
      secilenler.push(urun);

      const marka = urunMarkasiAl(urun);
      markaSayilari.set(marka, (markaSayilari.get(marka) || 0) + 1);

      urunKategoriEslesmeleri(urun).forEach(k => kapsananKategoriler.add(k));

      return true;
    }

    function adaySirala(liste, hedefKategori = null) {
      return [...liste].sort((a, b) => {
        const aSkor = Number(a.uyumSkoru) || 0;
        const bSkor = Number(b.uyumSkoru) || 0;

        const aBant = Math.floor((enYuksekSkor - aSkor) / 3);
        const bBant = Math.floor((enYuksekSkor - bSkor) / 3);
        if (aBant !== bBant) return aBant - bBant;

        const aMarka = urunMarkasiAl(a);
        const bMarka = urunMarkasiAl(b);
        const aMarkaCeza = markaSayilari.get(aMarka) || 0;
        const bMarkaCeza = markaSayilari.get(bMarka) || 0;
        if (aMarkaCeza !== bMarkaCeza) return aMarkaCeza - bMarkaCeza;

        if (hedefKategori) {
          const aHedef = urunKategoriEslesmeleri(a).includes(hedefKategori) ? 1 : 0;
          const bHedef = urunKategoriEslesmeleri(b).includes(hedefKategori) ? 1 : 0;
          if (aHedef !== bHedef) return bHedef - aHedef;
        }

        const aKategoriSayisi = urunKategoriEslesmeleri(a).length;
        const bKategoriSayisi = urunKategoriEslesmeleri(b).length;
        if (aKategoriSayisi !== bKategoriSayisi) return bKategoriSayisi - aKategoriSayisi;

        const aNeden = Array.isArray(a.nedenler) ? a.nedenler.length : 0;
        const bNeden = Array.isArray(b.nedenler) ? b.nedenler.length : 0;
        if (aNeden !== bNeden) return bNeden - aNeden;

        if (aSkor !== bSkor) return bSkor - aSkor;

        const aHash = stableHash(`${kullaniciSeed}::${secimTohumu}::${a.handle || a.id || a.title}`);
        const bHash = stableHash(`${kullaniciSeed}::${secimTohumu}::${b.handle || b.id || b.title}`);
        return bHash - aHash;
      });
    }

    ekle(adaySirala(adaylar)[0]);

    seciliKategoriler.forEach(kategori => {
      if (secilenler.length >= hedefSayi || kapsananKategoriler.has(kategori)) return;

      const kalanAdaylar = adaylar.filter(u => !kullanilanIdler.has(u.id));
      const kategoriAdaylari = kalanAdaylar.filter(u => urunKategoriEslesmeleri(u).includes(kategori));

      if (kategoriAdaylari.length > 0) {
        ekle(adaySirala(kategoriAdaylari, kategori)[0]);
      }
    });

    while (secilenler.length < hedefSayi) {
      const kalanAdaylar = adaylar.filter(u => !kullanilanIdler.has(u.id));
      if (kalanAdaylar.length === 0) break;

      ekle(adaySirala(kalanAdaylar)[0]);
    }

    if (secilenler.length < hedefSayi) {
      skorlanmisSonuc.forEach(urun => {
        if (secilenler.length < hedefSayi) ekle(urun);
      });
    }

    return secilenler;
  }

  function oneCikanUrunuBelirle(urunler) {
    if (!Array.isArray(urunler) || urunler.length === 0) return urunler;

    let enIyiIndex = 0;
    const kullaniciSeed = anonimKullaniciSeedAl();
    const secimTohumu = secimTohumuOlustur();

    urunler.forEach((urun, index) => {
      const mevcut = urunler[enIyiIndex];

      const urunSkor = Number(urun.uyumSkoru) || 0;
      const mevcutSkor = Number(mevcut.uyumSkoru) || 0;

      if (urunSkor > mevcutSkor) {
        enIyiIndex = index;
        return;
      }

      if (urunSkor < mevcutSkor) return;

      const urunNedenSayisi = Array.isArray(urun.nedenler) ? urun.nedenler.length : 0;
      const mevcutNedenSayisi = Array.isArray(mevcut.nedenler) ? mevcut.nedenler.length : 0;

      if (urunNedenSayisi > mevcutNedenSayisi) {
        enIyiIndex = index;
        return;
      }

      if (urunNedenSayisi < mevcutNedenSayisi) return;

      const urunIhtiyac = Array.isArray(urun.nedenler)
        ? urun.nedenler.some(n => normalizeText(n).includes('ihtiyaç'))
        : false;

      const mevcutIhtiyac = Array.isArray(mevcut.nedenler)
        ? mevcut.nedenler.some(n => normalizeText(n).includes('ihtiyaç'))
        : false;

      if (urunIhtiyac && !mevcutIhtiyac) {
        enIyiIndex = index;
        return;
      }

      if (!urunIhtiyac && mevcutIhtiyac) return;

      const urunHash = stableHash(`${kullaniciSeed}::${secimTohumu}::${urun.handle || urun.id || urun.title}`);
      const mevcutHash = stableHash(`${kullaniciSeed}::${secimTohumu}::${mevcut.handle || mevcut.id || mevcut.title}`);

      if (urunHash > mevcutHash) {
        enIyiIndex = index;
      }
    });

    return urunler.map((urun, index) => ({
      ...urun,
      oneCikan: index === enIyiIndex
    }));
  }

  function seciliYasDozMetafieldlari() {
    const map = {
      '4-10': ['11_yas_gunluk_kullanim_miktari'],
      '11-17': ['11_yas_gunluk_kullanim_miktari'],
      '18-24': ['18_yas_gunluk_kullanim_miktari'],
      '25-34': ['18_yas_gunluk_kullanim_miktari'],
      '35-44': ['18_yas_gunluk_kullanim_miktari'],
      '45-54': ['50_yas_gunluk_kullanim_miktari'],
      '55+': ['50_yas_gunluk_kullanim_miktari', '70_yas_gunluk_kullanim_miktari']
    };

    return map[secimler.yas] || [];
  }

  function hesaplaUyumSkoru(urun) {
    let skor = 72;

    const yasGrubu = getMetafield(urun.metafields, 'custom', 'hedef_yas_grubu');
    const urunFormu = getMetafield(urun.metafields, 'custom', 'urun_formu');
    const kategoriEslesmeleri = urunKategoriEslesmeleri(urun);
    const seciliKategoriler = Array.isArray(secimler.kategoriler)
      ? secimler.kategoriler.filter(k => normalizeText(k) !== 'farketmez')
      : [];

    if (secimler.yas && yasGrubuUyumluMu(secimler.yas, yasGrubu)) {
      skor += 8;

      if (
        (secimler.yas === '4-10' && yasGrubu === 'Çocuk') ||
        (['18-24', '25-34', '35-44', '45-54', '55+'].includes(secimler.yas) && ['Yetişkin Erkek', 'Yetişkin Kadın'].includes(yasGrubu))
      ) {
        skor += 2;
      }
    }

    const yasDozMetafieldlari = seciliYasDozMetafieldlari();
    if (
      yasDozMetafieldlari.length > 0 &&
      yasDozMetafieldlari.some(key => {
        const val = getMetafield(urun.metafields, 'custom', key);
        return val && String(val).trim() !== '';
      })
    ) {
      skor += 3;
    }

    if (formTercihiUyumluMu(secimler.form, urunFormu)) {
      skor += 8;

      if (normalizeText(secimler.form) === normalizeText(urunFormu)) {
        skor += 2;
      }
    }

    if (seciliKategoriler.length > 0) {
      const eslesmeSayisi = kategoriEslesmeleri.length;
      const eslesmeOrani = eslesmeSayisi / seciliKategoriler.length;

      skor += Math.min(eslesmeSayisi * 5, 15);

      if (eslesmeSayisi > 1) {
        skor += Math.min(eslesmeSayisi - 1, 3);
      }

      if (eslesmeOrani === 1) {
        skor += 4;
      } else if (eslesmeOrani >= 0.5) {
        skor += 2;
      }
    }

    if (
      secimler.cinsiyet &&
      (
        (secimler.cinsiyet === 'Kadın' && yasGrubu === 'Yetişkin Kadın') ||
        (secimler.cinsiyet === 'Erkek' && yasGrubu === 'Yetişkin Erkek')
      )
    ) {
      skor += 6;
    }

    const aktifKronikSayisi = Array.isArray(secimler.kronikler)
      ? secimler.kronikler.filter(k => k !== '').length
      : 0;

    if (aktifKronikSayisi > 0) {
      skor += Math.min(aktifKronikSayisi * 2, 4);
    }

    const cevaplananSoruSayisi = Object.keys(secimler.sorular || {}).length;
    if (cevaplananSoruSayisi > 0) {
      skor += Math.min(cevaplananSoruSayisi, 4);
    }

    const nedenSayisi = Array.isArray(urun.nedenler) ? urun.nedenler.length : 0;
    if (nedenSayisi > 0) {
      skor += Math.min(nedenSayisi, 3);
    }

    const stabilSkorTohumu = [
      urun.handle || urun.id || urun.title || '',
      secimTohumuOlustur()
    ].join('::');

    skor += stableHash(stabilSkorTohumu) % 3;

    if (skor > 98) skor = 98;
    if (skor < 72) skor = 72;

    return skor;
  }

  function dengeliUyumSkorlariUygula(urunler) {
    if (!Array.isArray(urunler) || urunler.length === 0) return urunler;

    let oncekiSkor = null;
    const ilkSkor = Number(urunler[0]?.uyumSkoru) || 92;
    const baslangicSkoru = Math.min(95, Math.max(88, ilkSkor));
    const kullaniciSeed = anonimKullaniciSeedAl();

    return urunler.map((urun, index) => {
      const stabilTohum = [
        urun.handle || urun.id || urun.title || '',
        secimler.yas || '',
        secimler.cinsiyet || '',
        secimler.gebelik || '',
        secimler.form || '',
        Array.isArray(secimler.kategoriler) ? secimler.kategoriler.join('|') : '',
        Array.isArray(secimler.kronikler) ? secimler.kronikler.join('|') : '',
        kullaniciSeed
      ].join('::');

      const stabilFark = stableHash(stabilTohum) % 2;
      let gosterilecekSkor = baslangicSkoru - (index * 2) - stabilFark;

      if (oncekiSkor !== null && gosterilecekSkor >= oncekiSkor) {
        gosterilecekSkor = oncekiSkor - 1;
      }

      gosterilecekSkor = Math.max(82, Math.min(95, gosterilecekSkor));
      oncekiSkor = gosterilecekSkor;

      return {
        ...urun,
        uyumSkoru: gosterilecekSkor
      };
    });
  }

  async function filtrele(urunler) {
    let sonuc = [...urunler];

    if (secimler.yas) {
      const YAS_MAP = {
        '4-10': ['Çocuk', 'Yetişkin & Çocuk'],
        '11-17': ['Yetişkin', 'Yetişkin & Çocuk'],
        '18-24': ['Yetişkin', 'Yetişkin & Çocuk', 'Yetişkin Erkek', 'Yetişkin Kadın'],
        '25-34': ['Yetişkin', 'Yetişkin & Çocuk', 'Yetişkin Erkek', 'Yetişkin Kadın'],
        '35-44': ['Yetişkin', 'Yetişkin & Çocuk', 'Yetişkin Erkek', 'Yetişkin Kadın'],
        '45-54': ['Yetişkin', 'Yetişkin & Çocuk', 'Yetişkin Erkek', 'Yetişkin Kadın'],
        '55+': ['Yetişkin', 'Yetişkin & Çocuk', 'Yetişkin Erkek', 'Yetişkin Kadın']
      };

      sonuc = sonuc.filter(u => {
        const yasGrubu = getMetafield(u.metafields, 'custom', 'hedef_yas_grubu');

        if (!yasGrubu) return true;

        const izinliDegerler = YAS_MAP[secimler.yas] || [];
        return izinliDegerler.includes(yasGrubu);
      });

      const YASA_OZEL_HARIC = {
        '4-10': [
          '11_yas_gunluk_kullanim_miktari',
          '18_yas_gunluk_kullanim_miktari',
          '50_yas_gunluk_kullanim_miktari',
          '70_yas_gunluk_kullanim_miktari'
        ],
        '11-17': [
          '18_yas_gunluk_kullanim_miktari',
          '50_yas_gunluk_kullanim_miktari',
          '70_yas_gunluk_kullanim_miktari'
        ],
        '18-24': [
          '50_yas_gunluk_kullanim_miktari',
          '70_yas_gunluk_kullanim_miktari'
        ],
        '25-34': [
          '50_yas_gunluk_kullanim_miktari',
          '70_yas_gunluk_kullanim_miktari'
        ],
        '35-44': [
          '50_yas_gunluk_kullanim_miktari',
          '70_yas_gunluk_kullanim_miktari'
        ],
        '45-54': [
          '70_yas_gunluk_kullanim_miktari'
        ],
        '55+': []
      };

      const haricTutulacakMetafieldlar = YASA_OZEL_HARIC[secimler.yas] || [];

      sonuc = sonuc.filter(u => {
        return !haricTutulacakMetafieldlar.some(key => {
          const val = getMetafield(u.metafields, 'custom', key);
          return val && String(val).trim() !== '';
        });
      });
      /* Kid / Kids / Miniza ürünleri sadece 4-10 yaş grubunda göster */
      sonuc = sonuc.filter(u => {
        const urunAdi = String(u.title || '').toLowerCase();
        const cocukUrunuMu = /(kids?|miniza)/i.test(urunAdi);

        if (cocukUrunuMu && secimler.yas !== '4-10') {
          return false;
        }

        return true;
      });
    }

    if (secimler.cinsiyet && secimler.cinsiyet !== 'Belirtmek istemiyorum') {
      const erkekOdakliKelimeler = [
        'erkek',
        'men',
        'male',
        'him',
        'formen',
        'arginmen',
        'wellman'
      ];

      const kadinOdakliKelimeler = [
        'kadın',
        'woman',
        'women',
        'fem',
        'female',
        'wellwoman'
      ];

      const gebelikOdakliKelimeler = [
        'mom',
        'pregna',
        'pregnancy',
        'mummy'
      ];

      const menopozOdakliKelimeler = [
        'menopace'
      ];

      sonuc = sonuc.filter(u => {
        const yasGrubu = getMetafield(u.metafields, 'custom', 'hedef_yas_grubu');
        const metin = getTumMetinler(u);

        if (secimler.cinsiyet === 'Kadın') {
          if (yasGrubu === 'Yetişkin Erkek') return false;
          if (erkekOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;

          if (secimler.gebelik === 'Hayır') {
            if (gebelikOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
          }

          if (secimler.gebelik === 'Gebe' || secimler.gebelik === 'Emziriyor') {
            if (menopozOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
          }
        }

        if (secimler.cinsiyet === 'Erkek') {
          if (yasGrubu === 'Yetişkin Kadın') return false;
          if (kadinOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
          if (gebelikOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
          if (menopozOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
        }

        if (secimler.cinsiyet === 'Kız Çocuk') {
          if (yasGrubu === 'Yetişkin Erkek') return false;
          if (erkekOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
          if (gebelikOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
          if (menopozOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
        }

        if (secimler.cinsiyet === 'Erkek Çocuk') {
          if (yasGrubu === 'Yetişkin Kadın') return false;
          if (kadinOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
          if (gebelikOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
          if (menopozOdakliKelimeler.some(k => metin.includes(k.toLowerCase()))) return false;
        }

        return true;
      });
    }

    if (
      secimler.kategoriler &&
      secimler.kategoriler.length > 0 &&
      !secimler.kategoriler.some(k => normalizeText(k) === 'farketmez')
    ) {
      const koleksiyonUrunIdleri = new Set();

      await Promise.all(secimler.kategoriler.map(async kategori => {
        const card = getCardByValue('kategori', kategori);
        const handle = card?.dataset?.handle;

        if (!handle) return;

        let cursor = null;
        let devam = true;

        while (devam) {
          const afterClause = cursor ? `, after: "${cursor}"` : '';
          const query = `{
            collection(handle: "${handle}") {
              products(first: 250${afterClause}) {
                pageInfo { hasNextPage endCursor }
                edges { node { id } }
              }
            }
          }`;

          const resp = await fetch(STOREFRONT_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
            },
            body: JSON.stringify({ query })
          });

          const json = await resp.json();
          const products = json.data?.collection?.products;

          if (!products) {
            devam = false;
            break;
          }

          products.edges.forEach(({ node }) => koleksiyonUrunIdleri.add(node.id));

          if (products.pageInfo.hasNextPage) {
            cursor = products.pageInfo.endCursor;
          } else {
            devam = false;
          }
        }
      }));

      sonuc = sonuc.filter(u => koleksiyonUrunIdleri.has(u.id));
    }

    if (
      secimler.form &&
      !['yok', 'farketmez'].includes(normalizeText(secimler.form))
    ) {
      const FORM_MAP = {
        'Kapsül': ['Kapsül', 'Kapsül (Softgel)'],
        'Tablet': ['Tablet', 'Dilaltı Tablet', 'Çiğneme Tableti'],
        'Çiğnenebilir': ['Çiğnenebilir Form', 'Çiğneme Tableti'],
        'Efervesan Tablet': ['Efervesan Tablet'],
        'Sıvı': ['Sıvı', 'Sıvı/Damla', 'Sıvı/Shot', 'Sıvı/Şişe', 'Sıvı/Tüp'],
        'Sprey': ['Sprey', 'Sprey/Damla'],
        'Toz': ['Toz'],
        'Saşe': ['Saşe'],
        'Pastil': ['Pastil']
      };

      const eslesecekFormlar = FORM_MAP[secimler.form] || [secimler.form];

      sonuc = sonuc.filter(u => {
        const urunFormu = getMetafield(u.metafields, 'custom', 'urun_formu');

        if (!urunFormu) return false;

        return eslesecekFormlar.some(f => urunFormu.toLowerCase() === f.toLowerCase());
      });
    }

    let uyariMesajlari = [];

    secimler.kronikler.forEach(kronikAd => {
      if (!kronikAd) return;

      const kronikCard = getCardByValue('kronik', kronikAd);
      if (!kronikCard) return;

      if (kronikCard.dataset.warning) {
        uyariMesajlari.push(kronikCard.dataset.warning);
      }

      const yasaklar = (kronikCard.dataset.keywords || '')
        .replace(/&#10;/g, '\n')
        .split(/[\n,]+/)
        .map(k => k.trim().toLowerCase())
        .filter(k => k);

      sonuc = sonuc.filter(u => {
        const tumMetinler = getTumMetinler(u);
        return !yasaklar.some(k => tumMetinler.includes(k));
      });
    });

    Object.entries(secimler.sorular).forEach(([alan, soru]) => {
      if (soru.value === 'Evet' && soru.kontra) {
        const kanSulandiriciYasaklar = ['warfarin', 'kan sulandırıcı', 'antikoagülan'];

        sonuc = sonuc.filter(u => {
          const tumMetinler = getTumMetinler(u);
          return !kanSulandiriciYasaklar.some(k => tumMetinler.includes(k.toLowerCase()));
        });
      }
    });


    /* Metaobject bazlı özel hariç tutmalar */
    const HARIC_TUTMA_KEY_MAP = {
      'gebe': 'gebe',
      'emziriyor': 'emziriyor',
      'böbrek rahatsızlığı': 'bobrek',
      'bobrek rahatsizligi': 'bobrek',
      'diyabet': 'diyabet',
      'gıda hassasiyeti': 'gida_hassasiyeti',
      'gida hassasiyeti': 'gida_hassasiyeti',
      'hipertansiyon': 'hipertansiyon',
      'kalp rahatsızlığı': 'kalp',
      'kalp rahatsizligi': 'kalp',
      'karaciğer rahatsızlığı': 'karaciger',
      'karaciger rahatsizligi': 'karaciger',
      'sindirim hassasiyeti': 'sindirim',
      'tiroid': 'tiroid'
    };

    function taHaricTutmaKeyAl(value) {
      const raw = normalizeText(value);
      const ascii = raw
        .replace(/ı/g, 'i')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c');

      return HARIC_TUTMA_KEY_MAP[raw] || HARIC_TUTMA_KEY_MAP[ascii] || ascii.replace(/\s+/g, '_');
    }

    const aktifHaricHandleleri = new Set();

    if (secimler.gebelik && secimler.gebelik !== 'Hayır') {
      const gebelikKey = taHaricTutmaKeyAl(secimler.gebelik);
      (TA_HARIC_TUTMA[gebelikKey] || []).forEach(h => aktifHaricHandleleri.add(String(h || '').trim()));
    }

    (secimler.kronikler || []).forEach(kronik => {
      if (!kronik) return;

      const key = taHaricTutmaKeyAl(kronik);
      (TA_HARIC_TUTMA[key] || []).forEach(h => aktifHaricHandleleri.add(String(h || '').trim()));
    });

    if (aktifHaricHandleleri.size > 0) {
      sonuc = sonuc.filter(u => {
        return !aktifHaricHandleleri.has(String(u.handle || '').trim());
      });
    }


    const oneriSayisi = parseInt((document.getElementById('ta-data') && JSON.parse(document.getElementById('ta-data').textContent || '{}').oneri_sayisi) || 6, 10) || 6;

    const skorlanmisSonuc = skorSiraliListele(
      sonuc.map(u => {
        const nedenler = nedenleriOlustur(u);

        return {
          ...u,
          nedenler,
          uyumSkoru: hesaplaUyumSkoru({ ...u, nedenler })
        };
      })
    );

    const akilliSecim = akilliCesitliUrunSec(skorlanmisSonuc, oneriSayisi);

    const nihai = oneCikanUrunuBelirle(
      dengeliUyumSkorlariUygula(akilliSecim)
    );

    return {
      urunler: nihai,
      uyari: uyariMesajlari
    };
  }

  function getTumMetinler(urun) {
    const tagsMetin = Array.isArray(urun.tags) ? urun.tags.join(' ') : (urun.tags || '');
    let metin = (urun.title + ' ' + urun.descriptionHtml + ' ' + tagsMetin).toLowerCase();

    if (urun.metafields) {
      urun.metafields.forEach(mf => {
        if (mf && mf.namespace === 'custom' && mf.value) {
          metin += ' ' + mf.value.toLowerCase();
        }
      });
    }

    return metin;
  }

  function getMetafield(metafields, namespace, key) {
    if (!metafields) return null;

    const mf = metafields.find(m => m && m.namespace === namespace && m.key === key);

    return mf ? mf.value : null;
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function yasalUyariGorunurlugunuAyarla(goster) {
    const legalNotice = document.getElementById('ta-yasal-uyari');

    if (!legalNotice) return;

    legalNotice.style.display = goster ? 'block' : 'none';
  }

  function guncelleSonucAciklamasi(urunSayisi) {
    const resultDesc = document.getElementById('ta-result-desc');

    if (!resultDesc) return;

    if (urunSayisi > 0) {
      resultDesc.innerHTML = `
        Seçimlerine göre senin için <strong>${urunSayisi} ürün</strong> listelendi.
        Bazı ürünler özel durumların ve tercihlerin doğrultusunda önerilere dahil edilmedi.
      `;
    } else {
      resultDesc.textContent = 'Seçimlerine uygun ürün eşleşmesi oluşturulamadı.';
    }
  }

  let taInfoLastFocused = null;

  function openInfoModal() {
    const modal = document.getElementById('ta-info-modal');
    const dialog = modal ? modal.querySelector('.ta-info-modal-dialog') : null;

    if (!modal || !dialog) return;

    taInfoLastFocused = document.activeElement;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ta-reason-lock');
    document.body.classList.add('ta-reason-lock');

    setTimeout(() => {
      dialog.focus();
    }, 30);
  }

  function closeInfoModal() {
    const modal = document.getElementById('ta-info-modal');

    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ta-reason-lock');
    document.body.classList.remove('ta-reason-lock');

    if (taInfoLastFocused && typeof taInfoLastFocused.focus === 'function') {
      setTimeout(() => taInfoLastFocused.focus(), 30);
    }
  }

  let taReasonLastFocused = null;

  function openReasonModal(productTitle, reasons) {
    const modal = document.getElementById('ta-reason-modal');
    const dialog = modal ? modal.querySelector('.ta-reason-dialog') : null;
    const productEl = document.getElementById('ta-reason-product');
    const listEl = document.getElementById('ta-reason-list');

    if (!modal || !dialog || !productEl || !listEl) return;

    taReasonLastFocused = document.activeElement;

    productEl.textContent = productTitle || '';
    listEl.innerHTML = '';

    (Array.isArray(reasons) && reasons.length ? reasons : ['Seçimlerine göre oluşturulan öneri havuzunda yer alıyor.'])
      .slice(0, 3)
      .forEach(reason => {
        const item = document.createElement('div');
        item.className = 'ta-reason-item';
        item.textContent = reason;
        listEl.appendChild(item);
      });

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ta-reason-lock');
    document.body.classList.add('ta-reason-lock');

    setTimeout(() => {
      dialog.focus();
    }, 30);
  }

  function closeReasonModal() {
    const modal = document.getElementById('ta-reason-modal');

    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ta-reason-lock');
    document.body.classList.remove('ta-reason-lock');

    if (taReasonLastFocused && typeof taReasonLastFocused.focus === 'function') {
      setTimeout(() => taReasonLastFocused.focus(), 30);
    }
  }

  document.addEventListener('click', function(event) {
    const warningToggle = event.target.closest('.ta-result-warning-toggle');

    if (warningToggle) {
      const warningBox = warningToggle.closest('.ta-result-warning');
      const isOpen = warningBox ? warningBox.classList.toggle('is-open') : false;
      warningToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }
  });

  document.addEventListener('click', function(event) {
    const infoTrigger = event.target.closest('#ta-info-modal-trigger');

    if (infoTrigger) {
      openInfoModal();
      return;
    }

    if (event.target.closest('[data-ta-info-close]')) {
      closeInfoModal();
      return;
    }
  });

  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('.ta-reason-trigger, .ta-rec-mobile-reason');

    if (trigger) {
      let reasons = [];

      try {
        reasons = JSON.parse(trigger.dataset.reasons || '[]');
      } catch(e) {
        reasons = [];
      }

      openReasonModal(trigger.dataset.product || '', reasons);
      return;
    }

    if (event.target.closest('[data-ta-reason-close]')) {
      closeReasonModal();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeReasonModal();
      closeInfoModal();
    }
  });

  function shopifyNumericId(gid) {
    return String(gid || '').split('/').pop();
  }

  function wishlistKingHTML(urun) {
    const variantId = shopifyNumericId(urun.variants?.edges?.[0]?.node?.id);
    const handle = urun.handle || '';
    const title = urun.title || '';

    if (!handle || !variantId) return '';

    return `
      <div
        class="ta-wishlist-slot"
        data-ta-wishlist-king
        data-product-handle="${escapeHTML(handle)}"
        data-variant-id="${escapeHTML(variantId)}"
        data-product-title="${escapeHTML(title)}"
        aria-label="${escapeHTML(title)} favori işlemleri">
      </div>
    `;
  }

  document.addEventListener('click', function(event) {
    const wishlistSlot = event.target.closest(
      '#takviye-asistani .ta-wishlist-slot[data-ta-wishlist-king]'
    );

    if (!wishlistSlot) return;

    taGA4Event('takviye_asistani_wishlist_click', {
      product_handle: wishlistSlot.dataset.productHandle || '',
      product_name: wishlistSlot.dataset.productTitle || ''
    });
  });

  document.addEventListener('click', async function(event) {
    const addBtn = event.target.closest('#takviye-asistani [data-ta-add-to-cart]');
    if (!addBtn) return;

    event.preventDefault();

    if (addBtn.disabled) return;

    const variantId = addBtn.dataset.variantId || '';
    const productUrl = addBtn.dataset.productUrl || '';
    const originalText = addBtn.textContent || 'Sepete Ekle';

    if (!variantId) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    addBtn.disabled = true;
    addBtn.classList.add('is-adding');
    addBtn.textContent = 'Ekleniyor...';

    try {
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      if (!resp.ok) {
        const err = await resp.json().catch(() => null);
        throw new Error(err?.description || err?.message || 'Sepete eklenemedi');
      }

      const item = await resp.json();

      addBtn.classList.remove('is-adding');
      addBtn.classList.add('is-added');
      addBtn.textContent = 'Sepete Eklendi';

      taGA4Event('takviye_asistani_add_to_cart', taAnalyticsPayload({
        product_handle: addBtn.dataset.productHandle || '',
        product_name: addBtn.dataset.productTitle || '',
        variant_id: variantId
      }));

      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'takviye-asistani', item } }));
        window.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'takviye-asistani', item } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'takviye-asistani', item } }));
      } catch (e) {}

      // Ürün sepete eklendikten sonra buton bu durumda kalır.
      // Böylece aynı ürün için tekrar "Sepete Ekle" durumuna dönmez.
      addBtn.disabled = true;
      addBtn.classList.add('is-added');
      addBtn.textContent = 'Sepete Eklendi';

    } catch (e) {
      console.warn('Takviye Asistanı sepete ekleme hatası:', e);

      addBtn.disabled = false;
      addBtn.classList.remove('is-adding');
      addBtn.textContent = 'Tekrar Dene';

      taGA4Event('takviye_asistani_add_to_cart_error', taAnalyticsPayload({
        product_handle: addBtn.dataset.productHandle || '',
        product_name: addBtn.dataset.productTitle || '',
        variant_id: variantId,
        error_message: e && e.message ? String(e.message).slice(0, 120) : 'unknown_error'
      }));

      window.setTimeout(() => {
        addBtn.textContent = originalText;
      }, 1600);
    }
  });

  document.addEventListener('click', function(event) {
    const productLink = event.target.closest('#takviye-asistani [data-ta-product-click]');

    if (!productLink) return;

    taGA4Event('takviye_asistani_product_click', {
      product_handle: productLink.dataset.productHandle || '',
      product_name: productLink.dataset.productTitle || '',
      click_area: productLink.dataset.clickArea || ''
    });
  });

  document.addEventListener('click', function(event) {
    const compareAllBtn = event.target.closest('#takviye-asistani #ta-compare-all-btn');
    if (!compareAllBtn) return;

    event.preventDefault();
    taCompareAllTetikle();
  });

  document.addEventListener('click', function(event) {
    const panelTrigger = event.target.closest('#takviye-asistani .ta-result-accordion-trigger');
    if (!panelTrigger) return;

    const panelKey = panelTrigger.dataset.taResultPanel;
    const content = document.querySelector(`#takviye-asistani [data-ta-result-panel-content="${panelKey}"]`);
    const expanded = panelTrigger.getAttribute('aria-expanded') === 'true';
    const triggerTopBefore = panelTrigger.getBoundingClientRect().top;

    panelTrigger.setAttribute('aria-expanded', String(!expanded));
    panelTrigger.classList.toggle('is-open', !expanded);

    if (content) {
      content.hidden = expanded;
    }

    if (!expanded && panelKey === 'summary') {
      window.requestAnimationFrame(() => {
        const triggerTopAfter = panelTrigger.getBoundingClientRect().top;
        const delta = triggerTopAfter - triggerTopBefore;

        if (Math.abs(delta) > 1) {
          window.scrollBy({
            top: delta,
            left: 0,
            behavior: 'auto'
          });
        }
      });
    }
  });

  document.addEventListener('click', function(event) {
    const warningToggle = event.target.closest('#takviye-asistani .ta-result-warning-toggle');

    if (!warningToggle) return;

    const warning = warningToggle.closest('.ta-result-warning');

    setTimeout(() => {
      taGA4Event('takviye_asistani_warning_toggle', {
        warning_open: warning ? String(warning.classList.contains('is-open')) : ''
      });
    }, 80);
  });

  function gosterSonuclar(sonuc) {
    resultsGrid.innerHTML = '';
    guncelleSonucPaneli(sonuc && Array.isArray(sonuc.urunler) ? sonuc.urunler.length : 0);
    taCompareAllAlaniGuncelle(sonuc && Array.isArray(sonuc.urunler) ? sonuc.urunler : []);
    taMobilSonucOzetiVarsayilanKapat();

    const resultWarning = document.getElementById('ta-result-warning');

    if (resultWarning) {
      resultWarning.style.display = 'none';
      resultWarning.innerHTML = '';
    }

    const resultScreen = document.getElementById('ta-result-screen');
    if (resultScreen) resultScreen.classList.remove('ta-result-screen--empty');

    if (!sonuc.urunler || sonuc.urunler.length === 0) {
      if (resultScreen) resultScreen.classList.add('ta-result-screen--empty');
      taGA4Event('takviye_asistani_empty_result', taAnalyticsPayload({
        result_count: 0,
        recommended_products: ''
      }));

      guncelleSonucAciklamasi(0);
      yasalUyariGorunurlugunuAyarla(false);

      const infoPanelTemplate = document.getElementById('ta-info-panel-template');

      resultsGrid.innerHTML = `
        <div class="ta-empty-layout">
          <div class="ta-empty-layout-left">
            <div class="ta-empty-state">
              <div class="ta-empty-state-head">
                <span class="ta-empty-state-icon" aria-hidden="true">!</span>
                <div>
                  <h3 class="ta-empty-state-title">Seçimlerini gözden geçirebilirsin</h3>
                  <p class="ta-empty-state-desc">Bazı seçimlerin ürün eşleşmelerini sınırlandırmış olabilir.</p>
                </div>
              </div>

              <div class="ta-empty-state-list" aria-label="Tekrar denemek için öneriler">
                <div class="ta-empty-state-item">
                  <span class="ta-empty-state-item-icon" aria-hidden="true">↺</span>
                  <span>Ürün formu tercihini değiştirebilirsin.</span>
                </div>
                <div class="ta-empty-state-item">
                  <span class="ta-empty-state-item-icon" aria-hidden="true">✓</span>
                  <span>Özel durum seçimlerini gözden geçirebilirsin.</span>
                </div>
                <div class="ta-empty-state-item">
                  <span class="ta-empty-state-item-icon" aria-hidden="true">→</span>
                  <span>Farklı seçimlerle tekrar deneyebilirsin.</span>
                </div>
              </div>

              <button type="button" class="ta-empty-back-btn" data-ta-empty-back>↻ ${TA_NEW_ANALYSIS_TEXT}</button>
            </div>
          </div>

          <aside class="ta-empty-layout-right ta-experience-right" aria-label="Bilgilendirme">
            ${infoPanelTemplate ? infoPanelTemplate.innerHTML : ''}
          </aside>
        </div>
      `;
      return;
    }

    taGA4Event('takviye_asistani_result', taAnalyticsPayload({
      result_count: sonuc.urunler.length,
      recommended_products: sonuc.urunler.map(u => u.handle || u.title || '').filter(Boolean).join('|'),
      top_product: sonuc.urunler[0]?.handle || sonuc.urunler[0]?.title || ''
    }));

    guncelleSonucAciklamasi(sonuc.urunler.length);
    yasalUyariGorunurlugunuAyarla(true);

    if (resultWarning && Array.isArray(sonuc.uyari) && sonuc.uyari.length > 0) {
      const uniqueWarnings = [...new Set(sonuc.uyari.filter(Boolean))];

      if (uniqueWarnings.length > 0) {
        const warningCount = uniqueWarnings.length;

        resultWarning.style.display = 'block';
        resultWarning.classList.remove('is-open');
        resultWarning.innerHTML = `
          <button type="button" class="ta-result-warning-toggle" aria-expanded="false">
            <span class="ta-result-warning-main">
              <span class="ta-result-warning-title">⚠️ Önemli Bilgilendirme (${warningCount})</span>
              <span class="ta-result-warning-summary">Dikkat edilmesi gereken bilgiler mevcut.</span>
            </span>
            <span class="ta-result-warning-icon" aria-hidden="true"></span>
          </button>
          <div class="ta-result-warning-content">
            ${uniqueWarnings.map(u => `<p>${escapeHTML(u)}</p>`).join('')}
          </div>
        `;
      }
    }

    sonuc.urunler.forEach((urun, index) => {
      const fiyat = urun.priceRange.minVariantPrice.amount;
      const para = urun.priceRange.minVariantPrice.currencyCode;
      const img = urun.featuredImage ? urun.featuredImage.url : '';
      const imgAlt = urun.featuredImage ? urun.featuredImage.altText : urun.title;
      const variantId = shopifyNumericId(urun.variants?.edges?.[0]?.node?.id);

      const kart = document.createElement('div');
      kart.className = 'ta-rec-card ta-product-card--enter wt-slider';
      kart.style.animationDelay = `${Math.min(index * 75, 450)}ms`;

      kart.innerHTML = `
${wishlistKingHTML(urun)}
  ${urun.oneCikan ? '<div class="ta-rec-featured" aria-label="Öne çıkan öneri">✨</div>' : ''}

  <div class="ta-rec-desktop">
    <a href="/products/${escapeHTML(urun.handle)}" class="ta-rec-media" target="_blank" rel="noopener noreferrer" data-ta-product-click data-product-handle="${escapeHTML(urun.handle)}" data-product-title="${escapeHTML(urun.title)}" data-click-area="image">
      ${img ? `<div class="ta-rec-image" style="background-image:url('${escapeHTML(img)}')" role="img" aria-label="${escapeHTML(imgAlt)}"></div>` : '<div class="ta-rec-image ta-rec-image--empty" aria-hidden="true"></div>'}
    </a>

    <div class="ta-rec-body">
      <a href="/products/${escapeHTML(urun.handle)}" class="ta-rec-title ta-rec-title-link" target="_blank" rel="noopener noreferrer" data-ta-product-click data-product-handle="${escapeHTML(urun.handle)}" data-product-title="${escapeHTML(urun.title)}" data-click-area="title">${escapeHTML(urun.title)}</a>

      <div class="ta-match ta-rec-match ta-rec-match--premium">
        <div class="ta-rec-score-label">AI Uyum Skoru</div>
        <div class="ta-rec-progress-row">
          <div class="ta-rec-bar">
            <div class="ta-match-fill ta-rec-fill" data-score="${urun.uyumSkoru}"></div>
          </div>
          <strong class="ta-match-score ta-rec-score" data-score="${urun.uyumSkoru}">%0</strong>
        </div>
      </div>

      <div class="ta-rec-actions ta-rec-actions--compare">
        <button type="button" class="ta-reason-trigger ta-rec-reason" data-reasons="${escapeHTML(JSON.stringify(urun.nedenler || []))}" data-product="${escapeHTML(urun.title)}">
          Neden sana uygun?
        </button>

        <div class="ta-rec-cta-row">
          <button type="button" class="ta-rec-link" data-ta-add-to-cart data-variant-id="${escapeHTML(variantId)}" data-product-handle="${escapeHTML(urun.handle)}" data-product-title="${escapeHTML(urun.title)}" data-product-url="/products/${escapeHTML(urun.handle)}">Sepete Ekle</button>

          <sc-add-to-compare product-handle="${escapeHTML(urun.handle)}" class="ta-rec-compare">
            <input id="ta-compare-d-${index}-${escapeHTML(urun.handle)}" type="checkbox" aria-label="${escapeHTML(urun.title)} ürününü karşılaştır">
            <label for="ta-compare-d-${index}-${escapeHTML(urun.handle)}">Karşılaştır</label>
          </sc-add-to-compare>
        </div>
      </div>
    </div>
  </div>

  <div class="ta-rec-mobile">
    <div class="ta-rec-mobile-top">
      <a href="/products/${escapeHTML(urun.handle)}" class="ta-rec-mobile-media" target="_blank" rel="noopener noreferrer" data-ta-product-click data-product-handle="${escapeHTML(urun.handle)}" data-product-title="${escapeHTML(urun.title)}" data-click-area="image">
        ${img ? `<div class="ta-rec-mobile-image" style="background-image:url('${escapeHTML(img)}')" role="img" aria-label="${escapeHTML(imgAlt)}"></div>` : '<div class="ta-rec-mobile-image ta-rec-image--empty" aria-hidden="true"></div>'}
      </a>

      <a href="/products/${escapeHTML(urun.handle)}" class="ta-rec-mobile-title ta-rec-title-link" target="_blank" rel="noopener noreferrer" data-ta-product-click data-product-handle="${escapeHTML(urun.handle)}" data-product-title="${escapeHTML(urun.title)}" data-click-area="mobile_title">${escapeHTML(urun.title)}</a>
    </div>

    <div class="ta-match ta-rec-mobile-match ta-rec-mobile-match--premium">
      <div class="ta-rec-mobile-score-label">AI Uyum Skoru</div>
      <div class="ta-rec-mobile-progress-row">
        <div class="ta-rec-mobile-bar">
          <div class="ta-match-fill ta-rec-mobile-fill" data-score="${urun.uyumSkoru}"></div>
        </div>
        <strong class="ta-match-score ta-rec-mobile-score" data-score="${urun.uyumSkoru}">%0</strong>
      </div>
    </div>

    <div class="ta-rec-mobile-actions ta-rec-mobile-actions--compare">
      <button type="button" class="ta-rec-mobile-reason" data-reasons="${escapeHTML(JSON.stringify(urun.nedenler || []))}" data-product="${escapeHTML(urun.title)}">
        Neden sana uygun?
      </button>

      <div class="ta-rec-mobile-cta-row">
        <button type="button" class="ta-rec-mobile-link" data-ta-add-to-cart data-variant-id="${escapeHTML(variantId)}" data-product-handle="${escapeHTML(urun.handle)}" data-product-title="${escapeHTML(urun.title)}" data-product-url="/products/${escapeHTML(urun.handle)}">Sepete Ekle</button>

        <sc-add-to-compare product-handle="${escapeHTML(urun.handle)}" class="ta-rec-mobile-compare">
          <input id="ta-compare-m-${index}-${escapeHTML(urun.handle)}" type="checkbox" aria-label="${escapeHTML(urun.title)} ürününü karşılaştır">
          <label for="ta-compare-m-${index}-${escapeHTML(urun.handle)}">Karşılaştır</label>
        </sc-add-to-compare>
      </div>
    </div>
  </div>

  <p class="ta-rec-price">${parseFloat(fiyat).toFixed(2)} ${escapeHTML(para)}</p>
`;

      resultsGrid.appendChild(kart);

      window.setTimeout(() => {
        kart.classList.remove('ta-product-card--enter');
        kart.style.animationDelay = '';
      }, Math.min(index * 75, 450) + 520);
    });

    requestAnimationFrame(() => {
      document.querySelectorAll('.ta-match-fill').forEach(bar => {
        const hedef = Math.max(0, Math.min(100, Number(bar.dataset.score) || 0));
        const match = bar.closest('.ta-match');
        const scoreEl = match ? match.querySelector('.ta-match-score') : null;

        bar.style.width = `${hedef}%`;

        if (!scoreEl) return;

        const duration = 1000;
        const start = performance.now();

        function animateScore(now) {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const current = Math.round(hedef * eased);

          scoreEl.textContent = `%${current}`;

          if (progress < 1) {
            requestAnimationFrame(animateScore);
          } else {
            scoreEl.textContent = `%${hedef}`;
          }
        }

        requestAnimationFrame(animateScore);
      });
    });
  }

  takviyeAsistaniPrefetchKur();

})();

(function() {
  function taStickyHeaderSync() {
    const root = document.getElementById('takviye-asistani');
    if (!root) return;

    const candidates = [
      '.shopify-section-header-sticky',
      '#shopify-section-header',
      'header'
    ];

    let maxHeight = 96;

    candidates.forEach(selector => {
      const el = document.querySelector(selector);
      if (!el) return;

      const rect = el.getBoundingClientRect();
      if (rect.height > 0) {
        maxHeight = Math.max(maxHeight, Math.ceil(rect.height));
      }
    });

    root.style.setProperty('--header-height', maxHeight + 'px');
  }

  taStickyHeaderSync();

  window.addEventListener('resize', taStickyHeaderSync, { passive: true });
  window.addEventListener('orientationchange', taStickyHeaderSync, { passive: true });
})();